import ApiService, { HttpMethod } from "../../../commons/api/api_service";
import BaseResponse from "../../../commons/api/base_response";
import { Endpoints } from "../../../commons/api/endpoints";
import ViewModelV2 from "../../../commons/base/v2/view_model";
import { FormItem, VendorReceiptHistory, VendorReceiptHistoryResponse, VendorReceiptHistoryItems, LocationModel } from '../models/vendor_receipt_history_model';

export default class VendorReceiptHistoryVM extends ViewModelV2 {
    
    isLoading: boolean = true;
    isLoadingDetail: boolean = false;
    isShowModal: boolean = false;
    errorMessage: string = "";
    searchBarValue: string = "";
    filteredForms: VendorReceiptHistory[] = [];
    vendorToOutletForms: VendorReceiptHistory[] = [];
    selectedForm?: VendorReceiptHistory;
    formItems?: FormItem[];
    locationOptions: LocationModel[] = [];
    selectedLocationId?: number;

    /**Return dd-mm-yyyy hh:mm:ss */
    formatTimestamp(date: Date): string[] {
        // get utc because in DB the time is UTC+14, so it will be UTC+7
         return [
            `${date.getUTCDate().toString().padStart(2, "0")}-` +
            `${(date.getUTCMonth()+1).toString().padStart(2, "0")}-` +
            `${date.getUTCFullYear()}`,

            `${date.getUTCHours().toString().padStart(2, "0")}:` +
            `${date.getUTCMinutes().toString().padStart(2, "0")}:` +
            `${date.getUTCSeconds().toString().padStart(2, "0")}`
        ];
    }

    constructor() {
        super();
        this.loadData();
        this.loadLocationOptions();
    }

    searchForm() {
        if (this.searchBarValue.length > 0) {
            const newArr = this.vendorToOutletForms.filter((form) => form.submit_code.includes(this.searchBarValue));
            this.emit(() => {
                this.filteredForms = newArr;
            });
        } else {
            this.emit(() => {
                this.filteredForms = this.vendorToOutletForms.slice();
            });
        }
    }

    async loadData() {
        this.emit(() => {
            this.isLoading = true;
        })

        ApiService.fetchWithQueryParams(
            Endpoints.getReceiptHistory,
            {
                httpMethod: HttpMethod.get,
                queryParameters: this.selectedLocationId && {
                    locationId: this.selectedLocationId,
                },
                onSuccess: (response: BaseResponse<typeof VendorReceiptHistoryResponse>) => {
                    if (response)
                        this.emit(() => {
                            this.isLoading = false;
                            this.vendorToOutletForms = response.data ?? [];
                            this.filteredForms = response.data ?? [];
                        });
                },
                onFailure: (error) => {
                    this.emit(() => {
                        this.isLoading = false;
                        this.errorMessage = error;
                    })
                }
            }
        )
    }

    loadLocationOptions() {
        this.emit(() => {
            this.isLoading = true;
        });

        ApiService.fetchWithQueryParams(
            Endpoints.getReceiptHistoryLocationOptions,
            {
                httpMethod: HttpMethod.get,
                onSuccess: (response: BaseResponse<LocationModel[]>) => {
                    if (response.code === 200) {
                        this.emit(() => {
                            this.locationOptions = response.data as LocationModel[];
                        });
                    }
                },
                onFailure: (error) => {
                    this.emit(() => {
                        this.isLoading = false;
                        this.errorMessage = error;
                    })
                }
            }
        )
    }

    changeSelectedLocation(locationId: number) {
        this.emit(() => {
            this.selectedLocationId = locationId;
        });

        this.loadData();
    }

    retryAction() {
        this.loadData();
    }

    loadFormDetail(form: VendorReceiptHistory) {
        this.emit(() => {
            this.isLoadingDetail = true;
            this.errorMessage = "";
            this.selectedForm = form;
        });

        ApiService.fetch<{}, BaseResponse<typeof VendorReceiptHistoryItems>>(
            Endpoints.getReceiptHistoryDetail,
            {
                parameters: { code: form.submit_code },
                onSuccess: (response) => {
                    if (response) {
                        this.emit(() => {
                            this.isShowModal = true;
                            this.isLoadingDetail = false;
                            this.formItems = response.data;
                        });
                    }
                },
                onFailure: (error) => {
                    this.emit(() => {
                        this.errorMessage = `${error}`;
                        this.isLoadingDetail = false;
                    });
                },
            }
        );
    }


}